// Google Analytics 4 Configuration
export const GA_MEASUREMENT_ID = 'G-N5L07RW27W'; // Your real Google Analytics ID

// Analytics Configuration
export const analyticsConfig = {
  // Enable analytics only in production or when explicitly enabled
  enabled: true, // Set to false to disable analytics
  
  // Google Analytics 4 Measurement ID
  measurementId: GA_MEASUREMENT_ID,
  
  // Debug mode (enable in development)
  debug: true, // Set to false in production
  
  // Cookie consent settings
  cookieConsent: {
    required: true, // Set to false to disable cookie consent requirement
    cookieName: 'ga_consent',
    expirationDays: 365
  }
};

// Event categories for tracking
export const EventCategories = {
  USER: 'User',
  BOOKING: 'Booking', 
  PAYMENT: 'Payment',
  NAVIGATION: 'Navigation',
  PROFILE: 'Profile',
  TIMESLOT: 'TimeSlot',
  ERROR: 'Error',
  /** AI interview chat UI */
  CHAT: 'AI Chat',
  /** First-party promotional cards (NativePromo) and conversion-funnel touchpoints. */
  PROMOTION: 'Promotion',
  CONVERSION: 'Conversion',
} as const;

// Event actions
export const EventActions = {
  // User actions
  SIGN_UP: 'sign_up',
  LOGIN: 'login',
  LOGOUT: 'logout',
  
  // Booking actions
  BOOKING_INITIATED: 'booking_initiated',
  BOOKING_COMPLETED: 'booking_completed',
  BOOKING_CANCELLED: 'booking_cancelled',
  
  // Payment actions
  PAYMENT_INITIATED: 'payment_initiated',
  PAYMENT_COMPLETED: 'payment_completed',
  PAYMENT_FAILED: 'payment_failed',
  
  // Profile actions
  PROFILE_COMPLETED: 'profile_completed',
  PROFILE_UPDATED: 'profile_updated',
  
  // TimeSlot actions
  TIMESLOT_CREATED: 'timeslot_created',
  TIMESLOT_DELETED: 'timeslot_deleted',
  
  // Guest demo
  GUEST_DEMO_START: 'guest_demo_start',
  GUEST_DEMO_QUOTA_HIT: 'guest_demo_quota_hit',
  GUEST_SIGNUP_CTA_CLICK: 'guest_signup_cta_click',
  GUEST_QUOTA_MODAL_VIEW: 'guest_quota_modal_view',

  // Native promo (first-party promotional cards rendered as ad-slot fallback)
  NATIVE_PROMO_VIEW: 'native_promo_view',
  NATIVE_PROMO_CLICK: 'native_promo_click',

  /** Fired when the interview chat panel is shown (one per session id). Use GA4 Explorations → unique users on this action. */
  AI_CHAT_OPEN: 'ai_chat_open',

  // Navigation
  PAGE_VIEW: 'page_view',
  
  // Errors
  ERROR_OCCURRED: 'error_occurred'
} as const;

export type EventCategory = typeof EventCategories[keyof typeof EventCategories];
export type EventAction = typeof EventActions[keyof typeof EventActions];
